export class SyncBackoffService {
    constructor() {
        this.backoffPenalties = new Map();
        this.backoffStartTimestamps = new Map();
    }
    isItemInBackoff(item) {
        const backoffStartingTimestamp = this.backoffStartTimestamps.get(item.uuid);
        if (!backoffStartingTimestamp) {
            return false;
        }
        const backoffPenalty = this.backoffPenalties.get(item.uuid);
        if (!backoffPenalty) {
            return false;
        }
        const backoffEndTimestamp = backoffStartingTimestamp + backoffPenalty;
        return backoffEndTimestamp > Date.now();
    }
    backoffItem(item) {
        const backoffPenalty = this.backoffPenalties.get(item.uuid) || 0;
        const newBackoffPenalty = backoffPenalty === 0 ? 1000 : backoffPenalty * 2;
        this.backoffPenalties.set(item.uuid, newBackoffPenalty);
        this.backoffStartTimestamps.set(item.uuid, Date.now());
    }
}
